var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.125,2.424c-12.931,0-23.451,10.52-23.451,23.451s10.52,23.45,23.451,23.45c12.932,0,23.451-10.52,23.451-23.45 S39.057,2.424,26.125,2.424z M26.125,45.701c-10.949,0-19.826-8.877-19.826-19.826S15.176,6.05,26.125,6.05 s19.826,8.876,19.826,19.825S37.074,45.701,26.125,45.701z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.369,
    y: 23.832,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -10.1809 26.2422)",
    width: 28.44,
    height: 3.159
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.368,
    y: 23.831,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 27.4217 62.1801)",
    width: 28.44,
    height: 3.16
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.125,0.424c-12.931,0-23.451,10.52-23.451,23.451s10.52,23.45,23.451,23.45 c12.932,0,23.451-10.52,23.451-23.45S37.057,0.424,24.125,0.424z M24.125,43.701c-10.949,0-19.826-8.877-19.826-19.826 S13.176,4.05,24.125,4.05s19.826,8.876,19.826,19.825S35.074,43.701,24.125,43.701z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.369,
    y: 21.832,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.3525 24.2423)",
    fill: "#FFFFFF",
    width: 28.44,
    height: 3.159
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.368,
    y: 21.831,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 25.4216 57.3517)",
    fill: "#FFFFFF",
    width: 28.44,
    height: 3.16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.d7a8faf2737399ea41db32743b93b96d.svg";
export { ForwardRef as ReactComponent };